module.exports = __webpack_public_path__ + "img/icon_5_92.74a4eb00.png";